import React from 'react'
import '../../pages/Home/Home.css'

export const ContainerValues = () => {
  return (
    <div className="ContainerValues">
        <img className="img1CV"src="https://res.cloudinary.com/dwj1w03r9/image/upload/v1680124145/Black_Blush_Elegant_Luxury_Name_Initial_Typography_Photography_Logo_12_apm61i.png" alt="" />
        <img className="img1CV"src="https://res.cloudinary.com/dwj1w03r9/image/upload/v1680124145/Black_Blush_Elegant_Luxury_Name_Initial_Typography_Photography_Logo_13_xnifgg.png" alt="" />
        <img className="img2CV"src="https://res.cloudinary.com/dwj1w03r9/image/upload/v1680124146/Black_Blush_Elegant_Luxury_Name_Initial_Typography_Photography_Logo_14_xsvjb2.png" alt="" />
    </div>
  )
}
